import Button from "./common/Button";
import DOMPurify from 'dompurify'

function SliderItemMember(props) {
  const lang = props.lang;
  let subheadStyle = {wordBreak:'keep-all'};
  let fontColor = props.colorscheme == 'yellow' ? 'tw-text-teal-dark' : 'tw-text-white';
  let bgColor = props.colorscheme == 'yellow' ? 'tw-bg-yellow' : 'tw-bg-teal-light';
  
  let classNames =
    "tw-min-h-72 xxs:tw-min-w-56 xs:tw-w-72 xmd:tw-w-auto xmd:tw-relative tw-no-underline tw-rounded-lg xmd:tw-rounded-2xl tw-overflow-hidden tw-group tw-block tw-cursor-pointer " + bgColor + " "+
    props.className;

  return (
    <div className={classNames} onClick={()=> { window.location.href = props.link}}>
      <div className=" tw-h-full tw-relative tw-inset-0 tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center tw-p-5 tw-pt-0">
        <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-flex-1">
          <p
            className={"tw-max-w-full "+fontColor+" tw-font-condensed tw-text-2xl md:tw-text-3xl tw-uppercase tw-leading-none tw-pt-4"}
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.title) }}
          ></p>
          <p className={fontColor+" tw-max-w-full tw-font-condensed tw-text-8xl md:tw-text-9xl tw-uppercase tw-leading-none tw-italic"}>{props.price}</p>
          <p style={subheadStyle}
            className={fontColor+" tw-max-w-full tw-font-condensed tw-text-xl tw-leading-none md:tw-leading-6 tw-uppercase tw-mt-1"}
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.subtitle) }}
          ></p>
          <p className={fontColor}
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.subtitle_description ? props.subtitle_description : "&nbsp;") }}
          ></p>
        </div>
        <Button
          href={props.link}
          title={props['button-text']}
          color="orange"
          size="large"
          className="tw-mt-4 tw-w-full"
        />
      </div>
    </div>
  );
}

export default SliderItemMember;
